module.exports = __webpack_public_path__ + "media/images/icons/form--stroke-738b90be3ace0046c7070cba37c44c75.svg";